export default class ValidationRules {
  static NonEmptyRule(inputError) {
    return v => v === 0 || v === false || !!v || inputError;
  }
}
